import React, { useEffect } from "react";

import useButtonLoader from "hooks/useButtonLoader";
import { CustomModal } from "components/modals/ModalBox";
import { useState } from "react";
import { toastMessage } from "utils/toastMessage";

import { addCategory, imgUploadToCloud } from "services/category";

import imgUploadToCloudFun from "components/modals/imgUploadAndGetUrl";
import { ImagePreview } from "utils/imagePreviewURLConverter";
import { Input } from "common/InputForm";
import {
  addBrandApi,
  editBrandApi,
  getSelectedBrand,
} from "services/brand-management";

const EditBrand = ({
  editBrandState,
  brandMgmtApiCall,
  closeModel,
  brandIdState,
}) => {
  const [error, setError] = useState({});

  // console.log("error, error message:-", error);

  const [buttonLoader, setButtonLoader] = useButtonLoader("Add");

  // ------------------------------image related states

  // -----cloud img
  const [imgInputState, setImageInputState] = useState("");
  // -------image preview related state
  const [imgPreviewState, seImgPreviewState] = useState(null);

  // ------------ cat name holder
  const [brandNameState, setBrandNameState] = useState("");

  // ---------------------apply coupon input Checkbox

  const [discountApply, setDiscountApply] = useState(false);
  const [couponNumberState, setCouponNumberState] = useState(0);

  // Input Validation
  const validation = () => {
    let status = true;
    let errorObject = {};

    // if (!imgInputState.length) {
    //   errorObject["imgEmptyErrorMsg"] = "Image is not Set";
    //   status = false;
    // }

    if (!brandNameState.length) {
      errorObject["brandName"] = "Brand Name is not Set";
      status = false;
    }

    setError(errorObject);

    return status;
  };

  // Add Brand close modal
  const addBrandCloseModal = () => {
    setImageInputState("");

    setBrandNameState("");
    setError({});

    brandMgmtApiCall();
    closeModel();
  };

  // Add Brand handler

  const editBrandHandler = async (e) => {
    e.preventDefault();

    if (validation()) {
      setButtonLoader(true);
      try {
        const dataToSend = {
          // image: imgInputState,
          name: brandNameState,
          isDiscountAvailable: discountApply,
          discountPercentage: couponNumberState,
        };

        imgInputState.length === 0
          ? (() => null)()
          : (dataToSend.image = imgInputState);

        const query = {
          data: dataToSend,
          brandIdState,
        };

        const { data } = await editBrandApi(query);
        // console.log();
        if (data.status || data.code === 200) {
          addBrandCloseModal();
        }
      } catch (e) {
        console.log("Error:", e.message);
      } finally {
        setButtonLoader(false);
      }
    }
  };

  const imgUploadFunction = async (e) => {
    if (!e?.target?.files[0]?.type.includes("image/")) {
      // ------for image preview i am string selected image data
      // -set error
      setError((stateProp) => ({
        ...stateProp,
        imgErrorOccur: "Please Choose Image file not others",
      }));
    } else {
      try {
        const data = await imgUploadToCloudFun(e?.target?.files[0]);
        // console.log("1st data?.data[0]:-------->", data?.data[0]);
        if (data?.status === 200) {
          //   console.log("2nd-------data?.data[0]:-------->", data?.data[0]);
          setImageInputState(data?.data[0]);
          seImgPreviewState(e?.target?.files[0]);
        }
      } catch (error) {
        console.log("error while uploading and getting data", error);
      }
    }
  };

  // ---------------------selected brand data

  const fetchSelectedBrandById = async () => {
    try {
      const {
        data: { status, code, data },
      } = await getSelectedBrand(brandIdState);

      if (status || code === 200) {
        seImgPreviewState(data?.image);
        setBrandNameState(data?.name);
        setDiscountApply(data?.isDiscountAvailable);
        setCouponNumberState(data?.discountPercentage);
      }
    } catch (error) {
      console.log("Error message of selected brand management", error);
    }
  };
  useEffect(() => {
    fetchSelectedBrandById();
  }, []);

  return (
    <CustomModal
      className={"add_model"}
      show={editBrandState}
      handleClose={addBrandCloseModal}
    >
      <h3>Edit Brand</h3>

      {/* ---------Category name and its types */}

      {/* ---------input tag name */}
      <div className="form_field">
        <Input
          className="form-control input"
          type="text"
          label="Brand Name"
          placeholder="Add Brand Name..."
          name="BrandNameTxt"
          value={brandNameState}
          onChange={(e) => {
            setBrandNameState(e.target.value);
          }}
        />
        {error["brandName"] && (
          <p className="red-color">{error["brandName"]}</p>
        )}
      </div>

      <div className="form_field">
        <input
          className="form-control input"
          onChange={imgUploadFunction}
          type="file"
          accept="image/*"
        />
        {!imgInputState.length && error["imgEmptyErrorMsg"] && (
          <span className="error">{error["imgEmptyErrorMsg"]}</span>
        )}
        {error["imgErrorOccur"] && (
          <p className="error">{error["imgErrorOccur"]}</p>
        )}

        {/* ------image preview Container div */}
        <div className="image_preview">
          {<ImagePreview file={imgPreviewState} />}
        </div>
        {/* ----end of img preview component */}
      </div>
      {/* ------------set coupon and checkbox  */}
      <div className="form_field">
        <label htmlFor="couponIdApply" className="label">
          <input
            id="couponIdApply"
            type="checkbox"
            onChange={(e) => {
              setDiscountApply(e.target.checked);
              if (!e.target.checked) {
                setCouponNumberState(0); // Reset the state itself
              }
            }}
            value={discountApply}
            checked={discountApply}
          />{" "}
          Apply Discount
        </label>

        <Input
          className="form-control input"
          type="number"
          name="couponNumber"
          value={couponNumberState}
          onChange={(e) => {
            setCouponNumberState(e.target.value);
          }}
          onKeyDown={(e) => {
            if (["e", "E", "+", "-", "."].includes(e.key)) {
              e.preventDefault();
            }
          }}
          disabled={!discountApply}
        />
      </div>

      <div className="button_wrap">
        <button
          type="button"
          className="button light"
          onClick={addBrandCloseModal}
        >
          Cancel
        </button>
        <button
          type="button"
          ref={buttonLoader}
          onClick={editBrandHandler}
          className="button"
        >
          Submit
        </button>
      </div>
    </CustomModal>
  );
};

export default EditBrand;
